<template>
  <div
    class="modal fade"
    id="certiAccInfoMModal"
    tabindex="-1"
    aria-labelledby="certiAccInfoWModalMModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              서티라이프 멤버 정보 수정하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalInputDiv">
              <label for="">이름</label>
              <input
                type="text"
                placeholder="이름을 입력해주세요."
                v-model="managerName"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">아이디</label>
              <span style="color: black">{{ managerId }}</span>
            </div>
            <div class="modalInputDiv">
              <label for="">휴대폰 번호</label>
              <input
                type="text"
                placeholder="휴대폰 번호를 입력해 주세요."
                v-model="managerPhoneNumber"
                maxlength="13"
                @input="changeManagerPhoneNumber"
              />
            </div>
            <div style="height: 30px;"/>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="modifyCertilifeAccount()"
          >
            수정하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openDialog, phoneNumberFormatter } from "../../utils/utils";

export default {
  data() {
    return {
      accountId: "", // 관리자 고유 id
      managerName: "", // 관리자 이름
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
    };
  },
  props: {
    data: {
      accountId: {
        type: String,
        required: false
      },
      managerName: {
        type: String,
        required: false
      },
      managerPhoneNumber: {
        type: String,
        required: false
      },
      managerId: {
        type: String,
        required: false
      },
    }
  },
  watch : {
    data: {
      immediate: true,
      deep: true,
      async handler(newValue, oldValue) {
        if(newValue && newValue.accountId !== this.accountId) {
          this.initValues();
          if(newValue.accountId) this.accountId = newValue.accountId;
          if(newValue.name) this.managerName = newValue.name;
          if(newValue.mobile) this.managerPhoneNumber = newValue.mobile;
          this.changeManagerPhoneNumber();
          if(newValue.username) this.managerId = newValue.username;
        }
      }
    }
  },
  async mounted() {
    this.initValues();
  },
  methods: {
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    // 주요 API

    // 계정 정보 수정
    async modifyCertilifeAccount() {
      if(await this.validateData()) {
        try {
          const obj = {};
          if(this.managerPhoneNumber) {
            obj.mobile = this.managerPhoneNumber.replace(/-/g, '');
          } else {
            obj.mobile = '';
          }

          if(this.managerName) {
            obj.name = this.managerName;
          } else {
            obj.name = '';
          }

          const response = await this.$apiInstance.put(`/accounts/certilife/${this.accountId}`, obj);
          if(response.status === 200 || response.status === 201) {
            await openDialog("계정 정보 수정이 완료되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
          } else {
            await openDialog("계정 정보 수정에 실패하였습니다.", "error", "확인");
          }
          
        } catch (error) {
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog("이미 존재하는 계정입니다.", "error", "확인");
          } else {
            await openDialog("계정 정보 수정에 실패하였습니다.", "error", "확인");
          }
        }
      }
    },


    // 업로드 전 검증
    async validateData() {
      let result = true;

      if (!this.managerName) {
        await openDialog("이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerId) {
        await openDialog("아이디를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerPhoneNumber) {
        await openDialog("휴대폰 번호를 입력해 주세요.", "error", "확인");
        result = false;
      } 
      return result;
    },

    
    // 기타 certiAccInfoM용 utils

    // 항목 초기화 용도
    initValues() {
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
    },
  },
};
</script>
